<template>
  <div
      :class="{ 'is-disabled': disabled }"
      class="lp-slider-row">
    <span
        v-if="label"
        class="lp-slider-row__label">{{ label }}</span>
    <input
        :value="value"
        :min="min"
        :max="max"
        :step="step"
        :disabled="disabled"
        :style="{ '--fill': fillPercent + '%' }"
        type="range"
        class="lp-slider-row__range"
        @input="$emit('input', Number($event.target.value))"
        @change="$emit('change', Number($event.target.value))"
        @keydown="noKeys && $event.preventDefault()"
        @mousedown="$emit('slide-start')"
        @mouseup="$emit('slide-end')">
    <span class="lp-slider-row__value">
      <input
          v-if="editable"
          :value="value"
          :min="min"
          :max="max"
          :disabled="disabled"
          type="number"
          @keydown.enter="commit"
          @blur="commit">
      <template v-else>{{ display === null ? value : display }}</template>{{ unit }}
    </span>
  </div>
</template>

<script>
export default {
  name:  'SliderRow',
  props: {
    label:    { type: String, default: '' },
    value:    { type: [Number, String], default: 0 },
    min:      { type: Number, default: 0 },
    max:      { type: Number, default: 100 },
    step:     { type: Number, default: 1 },
    unit:     { type: String, default: '' },
    display:  { type: [Number, String], default: null },
    editable: { type: Boolean, default: false },
    noKeys:   { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    fillPercent() {
      const range = this.max - this.min;
      return range > 0 ? Math.min(100, Math.max(0, ((Number(this.value) - this.min) / range) * 100)) : 0;
    },
  },
  methods: {
    commit(e) {
      const next     = Math.min(this.max, Math.max(this.min, Number(e.target.value) || 0));
      e.target.value = next;
      this.$emit('input', next);
      this.$emit('change', next);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-slider-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 32px;

  &.is-disabled {
    opacity: 0.5;
  }
}

.lp-slider-row__label {
  flex: 0 0 72px;
  font-size: $lp-fs-control;
  color: $lp-ink-2;
}

.lp-slider-row__range {
  flex: 1 1 auto;
  min-width: 0;
  height: 4px;
  border-radius: 4px;
  outline: none;
  background: linear-gradient(90deg, $lp-accent var(--fill), $lp-line var(--fill));
  -webkit-appearance: none;
  appearance: none;

  &::-webkit-slider-thumb {
    width: 16px;
    height: 16px;
    border: 2px solid $white;
    border-radius: 50%;
    background: $lp-accent;
    box-shadow: 0 1px 3px rgba(20, 22, 27, 0.3);
    cursor: pointer;
    -webkit-appearance: none;
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border: 2px solid $white;
    border-radius: 50%;
    background: $lp-accent;
    cursor: pointer;
  }
}

.lp-slider-row__value {
  display: flex;
  flex: 0 0 52px;
  align-items: center;
  justify-content: flex-end;
  font-family: $lp-mono;
  font-size: $lp-fs-control;
  color: $lp-ink;

  input {
    width: 44px;
    height: 28px;
    border: 0;
    border-radius: 6px;
    outline: none;
    background: $lp-fill;
    font: inherit;
    text-align: center;
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }
  }
}
</style>
